import { ErrorScreen } from '@/components/Error';

interface WasmLoadErrorFallbackProps {
    dashboardName: string;
    error?: Error | null;
}

export const WasmLoadErrorFallback = ({
    dashboardName,
    error,
}: WasmLoadErrorFallbackProps) => {
    return (
        <ErrorScreen
            error={{
                customMessage: `Couldn't initialize optimization engine for ${dashboardName}.`,
                message:
                    error?.message ||
                    'Please reload the page and try again. If the issue persists, contact support.',
            }}
        />
    );
};
